import { doc, runTransaction } from "firebase/firestore";
import { auth, db } from "./init-firebase";

/** Older archive endpoints only write is_active. Mark this archive before
 * calling them so a document restored from a previous archive is excluded
 * again. The marker has no effect while the class is active, including when
 * the following archive request fails. Only the current owner's deck is touched. */
export async function prepareDeckArchive(deckId: string, ownerId: string, signal?: AbortSignal): Promise<void> {
  const guard = () => {
    if (signal?.aborted || auth.currentUser?.uid !== ownerId) throw new Error("archive_session_changed");
  };
  guard();
  const archivedAt = new Date().toISOString();
  await runTransaction(db, async transaction => {
    guard();
    const reference = doc(db, "decks", deckId);
    const snapshot = await transaction.get(reference);
    guard();
    if (!snapshot.exists() || snapshot.data().user_id !== ownerId) throw new Error("archive_not_owned");
    // Retrying an already completed archive must preserve an explicit restore.
    if (snapshot.data().is_active === false) return;
    transaction.update(reference, { tutor_archived_at: archivedAt });
  });
  guard();
}
